function slideCartUpdate() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const item_count = cart.item_count
      const subtotal = cart.total_price / 100;
      const freeshipping_threshold = 300;
      const remaining_amount = (freeshipping_threshold - subtotal).toFixed(2);
      const cartCountEl = document.querySelector("#HeaderCartTrigger .cart-link__bubble-num");
      
      if (cartCountEl) {
        cartCountEl.textContent = item_count;
      }      

      showCartBanner();

      // Remove existing shipping text
      document
        .querySelectorAll(".qsc2-drawer .cart_shipping_text")
        .forEach((el) => el.remove());

      const header = document.querySelector(".qsc2-drawer .qsc2-drawer-header");
      if (!header) return;

      if (remaining_amount > 0 && remaining_amount < freeshipping_threshold) {
        const formatted_amount = `₹${remaining_amount.replace(".00", "")}`;
        const percentage = (subtotal / freeshipping_threshold) * 100;

        const html = `
          <div class="cart_shipping_text">
            <p><span>Add products worth</span> ${formatted_amount} <span>to avail free shipping and COD option</span></p>
            <div class="FreeShipping__ProgressBar">
              <div class="progress-bar_bg"></div>
              <div class="FreeShipping__ProgressLine" style="width:${percentage.toFixed(
                2
              )}%;">
                <div class="progress-line-circle FreeShipping__PlaneProgress finished-progress-bar">
                  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_453_468)">
                      <path fill="#000000" d="M11.7226 4.66667C12.5538 4.66667 14 5.37153 14 6.22222C14 7.09722 12.5538 7.77778 11.7226 7.77778H8.88854L6.44583 12.0531C6.30729 12.2938 6.04965 12.4444 5.77014 12.4444H4.40417C4.14653 12.4444 3.95938 12.1965 4.02986 11.9486L5.22326 7.77778H2.72222L1.67222 9.17778C1.59882 9.275 1.48361 9.33333 1.36111 9.33333H0.341007C0.152736 9.33333 0 9.18021 0 8.97118C0 8.96146 0.00441875 8.92986 0.0131201 8.89826L0.777778 6.22222L0.0131201 3.54618C0.00441875 3.51458 0 3.48299 0 3.45139C0 3.26424 0.152736 3.11111 0.341007 3.11111H1.36111C1.48361 3.11111 1.59882 3.16944 1.67222 3.26667L2.72222 4.66667H5.22326L4.02986 0.495833C3.95938 0.247188 4.14653 0 4.40417 0H5.77014C6.04965 0 6.30729 0.149552 6.44583 0.391806L8.88854 4.66667H11.7226Z"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_453_468">
                        <rect width="14" height="12.4444" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="FreeShipping__ProgressLine--Svg" style="width: 100%">
                  <div class="progress-bar-fill"></div>
                </div>
              </div>
            </div>
          </div>
        `;
        header.insertAdjacentHTML("afterend", html);
      } else if (remaining_amount <= 0) {
        const html = `<div class="cart_shipping_text"><h5>You're eligible for free shipping!</h5></div>`;
        header.insertAdjacentHTML("afterend", html);
      }
    });
}

function showCartBanner() {
  // Remove existing cart banner
  document
    .querySelectorAll(".qsc2-drawer .cart_banner")
    .forEach((el) => el.remove());

  const bannerHTML = `
    <div class="cart_banner">
      <img src="https://cdn.shopify.com/s/files/1/1380/2059/files/CART_BANNER_3.png?v=1748597545" />
    </div>
  `;

  const footer = document.querySelector(".qsc2-drawer .qsc2-drawer-footer");
  if (footer) {
    footer.insertAdjacentHTML("afterbegin", bannerHTML);
  }
}

// Attach event listeners
document.addEventListener("cart:change", slideCartUpdate);
document.addEventListener("cart-drawer:open", slideCartUpdate);






jQuery(document).ready(function(e) {
  jQuery('.products.cards.first').appendTo('.slider-section');
  jQuery('.products.cards.second').appendTo('.second-slider-section');
  jQuery('.products.cards.third').appendTo('.third-slider-section');
  jQuery('.products.cards.fourth').appendTo('.fourth-slider-section');
  jQuery('.products.cards.fifth').appendTo('.fifth-slider-section');
  jQuery('.products.cards.sixth').appendTo('.sixth-slider-section');
  $(document).ready(function () {
    var $carousel = $('.related_blog_products');
    $carousel.flickity({
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      autoPlay: 5000,
      groupCells: false // We control via CSS width
    });
    function updateSlidesToShow() {
      var width = $(window).width();
      var cellsToShow = 4;

      if (width <= 480) {
        cellsToShow = 1;
      } else if (width <= 768) {
        cellsToShow = 2;
      } else if (width <= 1024) {
        cellsToShow = 3;
      }
      var cellWidth = (100 / cellsToShow) + '%';
      $('.related_blog_products > li').css('width', cellWidth);

      $carousel.flickity('resize');
    }

    updateSlidesToShow();
    $(window).on('resize', updateSlidesToShow);
  });
});